import { createContext } from 'react';

import { EMPTY_PROMISE } from '../../constants';
import { WorkflowSession } from './types/WorkflowSession';

export const WorkflowSessionContext = createContext<WorkflowSession>({
  rootDocument: undefined,

  documentId: '',
  workflowName: '',
  place: undefined,
  targetPlace: undefined,

  hasInitialised: false,
  isLoading: true,

  reset: () => {},

  rehydrateRootDocument: EMPTY_PROMISE,
});
